export default __webpack_public_path__ + "static/media/logo.a57a345e.png";